import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment, URL } from "../../environments/environment";
import { BehaviorSubject, empty, Observable } from "rxjs";
import { jhcassoAPIUri } from "src/environments/apiUrl";
import { TokenResponse } from "../model/Response/TokenResponse";
import { UtilService } from "./util.service";
import { PMSTaskRequest } from "../model/Request/PMSTaskRequest";

// base url of app
const base_url = URL.enable == "1" ? URL.local : URL.live;
const base_urlUser = URL.enableUser == "1" ? URL.localUser : URL.liveUser;

@Injectable({
  providedIn: "root",
})
export class ApiService {
  public dataTransfer: any = new Object();
  total: number;
  totall: any;
  appointment: any;
  deviceToken: string;
  constructor(
  public http: HttpClient, 
  private util: UtilService
) { }
  pMSTaskRequest: PMSTaskRequest;
  pmsInfoGroupId = 26;

  newLogin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  setNewLogin(val) {
    this.newLogin.next(val);
  }

  isNewLogin() {
    return this.newLogin.asObservable();
  }



  public postWithHeader(url, data) {
    const tok = "Bearer " + localStorage.getItem("admin_token");
    let headers = new HttpHeaders();
    headers = headers.set("Authorization", tok);
    headers = headers.set("Accept", "application/json");

    this.http.post(base_url + url, data).subscribe((response: any) => {
      this.addInfoRequest(
        base_url + url,
        "postData Method Calls -> " + JSON.stringify(data),
        "POST",
        response
      );
    });

    return this.http.post(base_url + url, data, { headers: headers }).pipe();
  }

  addInfoRequest(url, data, type, response) {
    let header = new HttpHeaders();
    header = header.set("x-jacaso-key", "a1b2c33d4e5f6g7h8i9jakblc");
    header = header.set("Accept", "application/json");
    this.pMSTaskRequest = {
      name: type + " => " + url,
      description:
        type +
        " => Request Data Object : " +
        data +
        "  , Response Data Object :" +
        JSON.stringify(response),
    };
    //return this.http.post(this.Jhacasso_API_URL + "v1/pmstickets/task/" + this.pmsInfoGroupId, this.pMSTaskRequest, { headers: header });
    return this.http
      .post(
        URL.Jhacasso_API_URL + jhcassoAPIUri.pmsTaskUri + this.pmsInfoGroupId,
        this.pMSTaskRequest,
        { headers: header }
      )
      .subscribe((res: any) => {
        //console.log(res);
      });
  }

  addOneSignalReq(data) {
    let header = new HttpHeaders();
    header = header.set("x-jacaso-key", "a1b2c33d4e5f6g7h8i9jakblc");
    header = header.set("Accept", "application/json");
    this.pMSTaskRequest = {
      name: "addOneSignalReq => ",
      description:
        " => Request Data Object : " +
        data +
        "  , Response Data Object :" +
        JSON.stringify(data),
    };
    this.http
      .post(
        URL.Jhacasso_API_URL + jhcassoAPIUri.pmsTaskUri + this.pmsInfoGroupId,
        this.pMSTaskRequest,
        { headers: header }
      )
      .subscribe((res: any) => {
        //console.log(res);
      });
  }

  get(url) {
    let header = new HttpHeaders();
    header = header.set("x-jacaso-key", environment.authKey);
    header = header.set("o-jacaso-key", environment.appKey);
    header = header.set("Accept", "application/json");
    return this.http.get(URL.Jhacasso_API_URL + url, {
      headers: header,
    });
  }

  postAuth(url, data) {
    let header = new HttpHeaders();
    header = header.set("x-jacaso-key", environment.authKey);
    header = header.set("Accept", "application/json");
    return this.http.post(URL.Jhacasso_API_URL + url, data, {
      headers: header,
    });
  }

  post(url, data) {
    let header = new HttpHeaders();
    header = header.set("o-jacaso-key", environment.appKey);
    header = header.set(
      "Authorization",
      "Bearer " + localStorage.getItem("xtoken")
    );
    header = header.set("Accept", "application/json");
    return this.http.post(URL.Jhacasso_API_URL + url, data, {
      headers: header,
    });
  }

  sendOtpRequest(url, data) {
    let header = new HttpHeaders();
    header = header.set("x-jacaso-key", environment.authKey);
    header = header.set("Accept", "application/json");
    return this.http.post(URL.Jhacasso_API_URL + url, data, {
      headers: header,
    });
  }

  postVerifyOtpRequest(url, data) {
    let header = new HttpHeaders();
    header = header.set("x-jacaso-key", environment.authKey);
    header = header.set("o-jacaso-key", environment.appKey);
    header = header.set("Accept", "application/json");
    return this.http.post(URL.Jhacasso_API_URL + url, data, {
      headers: header,
    });
  }

  resendOtpRequest(url, param) {
    let header = new HttpHeaders();
    header = header.set("x-jacaso-key", environment.authKey);
    header = header.set("Accept", "application/json");

    return this.http.get(URL.Jhacasso_API_URL + url + param, {
      headers: header,
    });
  }

  postWithAllKey(url, data) {
    let header = new HttpHeaders();
    header = header.set("x-jacaso-key", environment.authKey);
    header = header.set("o-jacaso-key", environment.appKey);
    header = header.set("Accept", "application/json");
    return this.http.post(URL.Jhacasso_API_URL + url, data, {
      headers: header,
    });
  }

  put(url, data) {
    let header = new HttpHeaders();
    header = header.set("o-jacaso-key", environment.appKey);
    header = header.set(
      "Authorization",
      "Bearer " + localStorage.getItem("xtoken")
    );
    header = header.set("Accept", "application/json");

    return this.http.put(URL.Jhacasso_API_URL + url, data, {
      headers: header,
    });
  }

  // Handle Token Services Code Below
  GenerateRefreshToken() {
    const input = {
      AccessToken: this.GetToken(),
      RefreshToken: this.GetRefreshToken(),
    };
    let header = new HttpHeaders();
    header = header.set("x-jacaso-key", environment.authKey);
    header = header.set("o-jacaso-key", environment.appKey);
    header = header.set("Accept", "application/json");

    return this.http.post(
      URL.Jhacasso_API_URL + jhcassoAPIUri.refreshToken,
      input,
      { headers: header }
    );
  }

  IsLogged() {
    return localStorage.getItem(environment.xToken) != null;
  }
  GetToken() {
    return localStorage.getItem(environment.xToken) || "";
  }
  GetRefreshToken() {
    return localStorage.getItem(environment.xrefreshToken) || "";
  }

  SaveTokens(tokendata: TokenResponse) {
    localStorage.setItem(environment.xToken, tokendata.token);
    localStorage.setItem(environment.xrefreshToken, tokendata.refreshToken);
    localStorage.setItem(environment.uId, tokendata.userId.toString());
    //localStorage.setItem(environment.sId, tokendata.userId);
  }

  onLogOut() {
    localStorage.removeItem("admin_token");

    localStorage.removeItem("adminKey");
    localStorage.removeItem(environment.xToken);
    localStorage.removeItem(environment.xrefreshToken);
    // this.postWithAllKey(jhcassoAPIUri.logout, empty)
    //   .subscribe(async (res: any) => {
    //     //
    //   });
    this.util.navCtrl.navigateForward("signin");
  }

  delete(url: any) {
    let header = new HttpHeaders();
    header = header.set("o-jacaso-key", environment.appKey);
    header = header.set(
      "Authorization",
      "Bearer " + localStorage.getItem("xtoken")
    );
    header = header.set("Accept", "application/json");

    return this.http.delete(URL.Jhacasso_API_URL + url, {
      headers: header,
    });
  }

  postTicket(url, data) {
    let header = new HttpHeaders();
    header = header.set("x-jacaso-key", "a1b2c33d4e5f6g7h8i9jakblc");
    header = header.set("Accept", "application/json");
    this.pMSTaskRequest = {
      name: data.name,
      description: data.description
    };
    return this.http
      .post(
        URL.Jhacasso_API_URL + jhcassoAPIUri.pmsTaskUri + 30,
        this.pMSTaskRequest,
        { headers: header }
      )
  }
}